import {
  GET_USER,
  SET_SETTINGS,
  RESET,
  SET_INFO,
  SET_TRANSFER,
  SET_CURVES,
  PATIENT_DETAILS,
  COMPILANCE_LIST,
  SET_STATUS,
  SET_DIAGNOSIS,
  SET_PASS,
  CLEAR_SELECTED_PATIENT,
  DIAGNOSIS_LOAD,
  SET_SELECTED_USER,
  SET_DIAGNOSIS_IMAGE,
} from '../actions/types';

const initialState = {
  selectedPatient: null,
  selectedUser: null,
  diagnoseLoading: true,
  succesMessage: '',
  error: '',
  errorModal: '',
  patient: {
    personalInfo: null,
    settings: null,
    transferList: null,
    compilanceList: null,
    curvesList: null,
    details: null,
    diagnosis: null,
    imageUrls: [],
  },
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_SELECTED_USER:
      return { ...state, selectedUser: payload };
    case GET_USER:
      if (payload == null) console.log('No User');
      return { ...state, user: payload };
    case RESET:
      return {
        ...state,
        user: payload,
      };
    case DIAGNOSIS_LOAD: {
      console.log('DIAGNOSIS_LOAD');
      return {
        ...state,
        diagnoseLoading: true,
      };
    }

    case SET_INFO:
      return {
        ...state,
        selectedPatient: payload,
        patient: { ...state.patient, personalInfo: { ...payload } },
      };

    case SET_SETTINGS:
      return {
        ...state,
        patient: { ...state.patient, settings: { ...payload } },
      };
    case SET_TRANSFER:
      return { ...state, patient: { ...state.patient, transferList: payload } };
    case COMPILANCE_LIST:
      return {
        ...state,
        patient: { ...state.patient, compilanceList: payload },
      };
    case SET_CURVES:
      return {
        ...state,
        patient: { ...state.patient, curvesList: { ...payload } },
      };
    case PATIENT_DETAILS:
      return {
        ...state,
        patient: { ...state.patient, details: { ...payload } },
      };
    case SET_STATUS:
      return {
        ...state,
        patient: { ...state.patient, status: payload.status },
      };
    case SET_DIAGNOSIS:
      return {
        ...state,
        diagnoseLoading: false,
        patient: { ...state.patient, diagnosis: payload },
      };
    // case SET_DIAGNOSIS_IMAGE:
    //   return {
    //     ...state,
    //     diagnoseLoading: false,
    //     patient: { ...state.patient, diagnosisimage: payload },
    //   };
    case CLEAR_SELECTED_PATIENT:
      return { ...state, patient: {} };
    case SET_PASS:
      return { ...state, patient: { ...state.patient } };
    default:
      return state;
  }
};
